module.exports = __webpack_public_path__ + "static/media/Offer .1d1379c2.svg";